import { AuthenticationService } from './../../shared/authentication.service';
import { Configuration, SavedConfiguration } from './../../shared/configuration.model';

import { LocalStorage } from '../../shared/localstorage.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, ErrorStateMatcher, MAT_DIALOG_DATA } from '@angular/material';
import { AttributeNames, SourceValues, AttributeNameValues } from '../../shared/createattribute.model';
import { CreateAttributeService } from '../../shared/createattribute.service';
import { ticketType } from '../../shared/ticket-types.model';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { isNullOrUndefined } from 'util';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
  selector: 'app-my-dialog',
  templateUrl: './my-dialog.component.html',
  styleUrls: ['./my-dialog.component.scss']
})
export class MyDialogComponent implements OnInit {

  nameFormControl = new FormControl('', [
    Validators.required
  ]);

  valueFormControl = new FormControl('', [
    Validators.required
  ]);

  countFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern('^(0|[1-9][0-9]*)$')
  ]);

  sourceTypeFormControl = new FormControl('', [
    Validators.required
  ]);

  selectedSource: string = '';

  sourceType: string = '';

  selectedSourceValue: string = '';

  sourceValueCount: string = '';
  matcher = new MyErrorStateMatcher();
  type: string;
  sourceValues: SourceValues[] = [];

  sources: AttributeNames[];

  attributeValues: AttributeNameValues[];
  tickettypes: ticketType[];

  configId: number;

  constructor(public thisDialogRef: MatDialogRef<MyDialogComponent>, public service: CreateAttributeService,  @Inject(MAT_DIALOG_DATA) public data: SavedConfiguration, public auth: AuthenticationService) { }

  ngOnInit() {
    if(isNullOrUndefined(this.data)){
    this.service.getQualityAttributes(this.auth.currentState).subscribe((res: AttributeNames[]) => {
      this.sources = res;
    });
  }
  else{
    this.configId = this.data.ConfigId;
    this.selectedSource = this.data.QualityAttribute;
    this.selectedSourceValue = this.data.QualityAttributeValue;
    this.sourceType = this.data.SourceType;
    this.sourceValueCount = this.data.QualityAttributeCount.toString();
  }
  }

  OnCloseConfirm() {
    if(isNullOrUndefined(this.data)){
    if (!this.nameFormControl.errors && !this.valueFormControl.errors && !this.countFormControl.errors &&
      !this.sourceTypeFormControl.errors) {
      this.thisDialogRef.close({
        source: this.selectedSource, sourcevalue: this.selectedSourceValue, sourcevaluecount: this.sourceValueCount,
        configurationtype: this.sourceType
      });
    }
  }
  else{
    this.thisDialogRef.close({
      configid: this.configId, source: this.selectedSource, sourcevalue: this.selectedSourceValue, sourcevaluecount: this.sourceValueCount,
      configurationtype: this.sourceType
    });
  }
  }

  OnCloseCancel() {
    this.thisDialogRef.close('Cancel');
  }

  OnSourceClick(id: number, name: string) {
    this.sourceValues = [];
    for (let i = 0; i <= this.sourceValues.length; i++) {
      this.sourceValues.splice[i];
    }

    this.service.getQualityAttributeValues(id, this.auth.currentState).subscribe((res: AttributeNameValues[]) => {
      
      this.attributeValues = res;
      for (let attributevalue of this.attributeValues) {
        this.sourceValues.push({ Value: attributevalue.GCAttributeID, ViewValue: attributevalue.GCAttributeValueName });
      }
    });

    this.sourceValues = [];
  }
}
